import React from "react";
import styled from "styled-components";
import { IC } from "../../../resources/Assets";

export default (props) => {
    const { setIsDisplay, setDateTarget, srchFrDt, srchToDt } = props;
    return(
        <DateInput>
            <RoundBar>
                <IpBox onClick={()=>{
                    setIsDisplay(true)
                    setDateTarget('FROM')
                }}>
                    <DateInputBox 
                        type="text" 
                        id="dateFrom" 
                        placeholder="선택하세요."
                        defaultValue={srchFrDt 
                            ? (srchFrDt.substring(0,4) + '.' + srchFrDt.substring(4,6) + '.' + srchFrDt.substring(6,8))
                            : ''
                        }
                        readOnly 
                    />
                    <DateInputI />
                </IpBox>
                <DateInputU>~</DateInputU>
                <IpBox onClick={()=>{
                    setIsDisplay(true)
                    setDateTarget('TO')
                }}>
                    <DateInputBox
                        type="text" 
                        id="dateTo" 
                        placeholder="선택하세요."
                        defaultValue={srchToDt 
                            ? (srchToDt.substring(0,4) + '.' + srchToDt.substring(4,6) + '.' + srchToDt.substring(6,8))
                            : ''
                        }
                        readOnly 
                    />
                    <DateInputI />
                </IpBox>
            </RoundBar>
        </DateInput>
    )
}

const DateInput = styled.div`
    display:block;
`

const RoundBar = styled.div`
    height: 42px;
    border-radius: 7px;
    background: #fff;
    border: 1px solid #d0d0d0;
    font-size: 0;
    padding: 6px 13px 0;
    display: flex;
`

const IpBox = styled.div`
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: calc(50%-23px);
`
const DateInputBox = styled.input`
    z-index: 1;
    position: relative;
    height: 35px;
    padding-right: 28px;
    border: 0;
    width: 100%;
    background: transparent;
    box-sizing: border-box;
    font-size: 14px;
    color: #222;
    font-weight: 400;
    outline: 0;
`

const DateInputU = styled.u`
    text-decoration: none;
    display: inline-block;
    vertical-align: top;
    width: 46px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 14px;
    color: #222;
`

const DateInputI = styled.i`
    position: absolute;
    right: 0 !important;
    top: 7px !important;
    width: 19px;
    height: 21px;
    background:url(${IC.etc.calendar}) no-repeat left top;
    background-size: contain;
`